import h from 'virtual-dom/h';
import SectionBuilder from "./builders/sectionBuilder";
import {DefaultSettings, settings} from '../../../settings/settings-util';
import {VChild, VTree, VNode} from "virtual-dom";
import {HistoryMessage, HistoryMessageAlme} from "../../../types/history";
import {Reducer, Store} from "redux";
import {AlmeState, defaultState} from "../../../wireup/AlmeState";
import {DisplayLinkCollection} from "@alme/types/response/DisplayLinkCollection";
import {DisplayLinkSection} from "@alme/types/response/DisplayLinkSection";
import {Mutator} from "../../../types/rendering";

type StepOutIcon = { renderIcon: (url: string) => VNode | undefined };
type MutatorModule = { getMutator: () => Mutator };

export default class DisplayLinksRenderer
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _sectionBuilder: SectionBuilder;

    //#region Public Interface

    constructor(passedSettings?: DefaultSettings,
                stepOutIcon: StepOutIcon | null = null,
                linkMutatorModules: MutatorModule[] = [],
            )
    {
        this._settings = passedSettings ?? settings;

        let linkMutators = linkMutatorModules.reduce((mutators, module) => [...mutators, module.getMutator()], [] as Mutator[]);
        this._sectionBuilder = new SectionBuilder(this._settings, stepOutIcon, linkMutators);
    }

    static getDefaultSettings(): DefaultSettings
    {
        return settings;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
        this._sectionBuilder.initialize(store);
    }

    getReducer(): Reducer<AlmeState>
    {
        return (state: AlmeState = defaultState): AlmeState => state;
    }

    doesRender(message: HistoryMessage): boolean
    {
        const collection = (message as HistoryMessageAlme).displayLinkCollection as DisplayLinkCollection;

        return !!collection && this.containsDisplayLinks(collection);
    }

    getRenderer(): (message: HistoryMessage) => VChild
    {
        return (message: HistoryMessage): VChild =>
        {
            if (!this.doesRender(message)) { return []; }

            const sections = (message as HistoryMessageAlme).displayLinkCollection?.Sections as DisplayLinkSection[];
            const sectionNodes = sections.reduce((currentSections, section) =>
                [...currentSections, ...this._sectionBuilder.buildSection(section, message as HistoryMessageAlme)], [] as VTree[]);

            return h('div', { className: this._settings.classNames.displayLinksCollection }, sectionNodes);
        };
    }

    //#endregion



    //#region Helper Methods

    containsDisplayLinks(collection: DisplayLinkCollection): boolean
    {
        return collection.Sections.reduce((containsLinks: boolean, section) => containsLinks || (section.Links.length > 0), false);
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/message-renderer-display-links/src/message-renderer-display-links.ts